<template>
  <v-dialog :value="value" @input="closeDialog" max-width="500px" persistent>
    <v-card dark rounded="xl">
      <v-sheet
        height="120px"
        :style="{ background: `linear-gradient(to right, var(--v-primary-base), #1de9b6)` }"
        class="d-flex justify-center align-center">
        <v-icon size="70" dark>mdi-chat-plus-outline</v-icon>
      </v-sheet>

      <v-card-title class="headline justify-center pt-6"> Einzelchat starten </v-card-title>

      <v-card-text class="pa-6">
        <v-text-field
          v-model="searchQuery"
          placeholder="Person suchen..."
          filled
          rounded
          dense
          hide-details
          dark
          clearable
          prepend-inner-icon="mdi-magnify"
          class="mb-4 glass-search-field"></v-text-field>

        <div v-if="isLoading" class="text-center pa-4">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <div class="mt-2 grey--text">Lade verfügbare Personen...</div>
        </div>

        <div v-else-if="filteredUsers.length === 0" class="text-center grey--text text--darken-1 pa-4">
          <v-icon size="40" color="grey darken-3" class="mb-2">mdi-account-cancel-outline</v-icon>
          <div>Keine Personen gefunden.</div>
        </div>

        <v-list v-else dark class="transparent user-list-scroll">
          <v-list-item v-for="user in filteredUsers" :key="user._id" @click="startChat(user)" class="mb-1 rounded-lg user-list-item">
            <v-list-item-avatar>
              <v-img v-if="user.bild" :src="'/img/profilbilder/' + user.bild" alt="Profilbild"></v-img>
              <div v-else class="fallback-avatar backup-avatar d-flex align-center justify-center white--text font-weight-bold">
                {{ getInitials(user) }}
              </div>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">{{ user.vorname }} {{ user.nachname }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon small color="grey darken-1">mdi-message-text-outline</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions class="pa-6 pt-0">
        <v-btn text @click="closeDialog" :disabled="isStarting"> Abbrechen </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"
import { mapActions } from "vuex"

export default {
  name: "ChatDirectCreateDialog",
  props: ["value"],
  data() {
    return {
      searchQuery: "",
      isLoading: false,
      isStarting: false,
      eligibleUsers: [],
    }
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) return this.eligibleUsers
      const lowerQuery = this.searchQuery.toLowerCase()
      return this.eligibleUsers.filter(
        (u) => (u.vorname && u.vorname.toLowerCase().includes(lowerQuery)) || (u.nachname && u.nachname.toLowerCase().includes(lowerQuery)),
      )
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.fetchUsers()
        this.searchQuery = ""
      }
    },
  },
  methods: {
    ...mapActions("chatStore", ["startDirectChat"]),

    async fetchUsers() {
      this.isLoading = true
      try {
        const { data } = await api.fetchEligibleDirectChatUsers()
        this.eligibleUsers = data
      } catch (err) {
        console.error("Fehler beim Laden der Benutzer", err)
      } finally {
        this.isLoading = false
      }
    },

    async startChat(user) {
      if (this.isStarting) return
      this.isStarting = true

      try {
        await this.startDirectChat(user._id)
        this.$emit("chat-started")
        this.closeDialog()
      } catch (err) {
        console.error("Konnte Chat nicht starten", err)
      } finally {
        this.isStarting = false
      }
    },

    getInitials(user) {
      const v = user.vorname || ""
      const n = user.nachname || ""
      return `${v.charAt(0).toUpperCase()}${n.charAt(0).toUpperCase()}`
    },

    closeDialog() {
      if (this.isStarting) return
      this.$emit("input", false)
    },
  },
}
</script>

<style lang="scss" scoped>
.glass-search-field {
  ::v-deep .v-input__slot {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
  }
}

.user-list-scroll {
  max-height: 300px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }
}

.user-list-item {
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.02);
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    cursor: pointer;
    transform: translateX(4px);
  }
}

.backup-avatar {
  background: linear-gradient(135deg, #333, #111);
  width: 100%;
  height: 100%;
}
</style>
